import { motion } from "framer-motion";
import { FileText, Mail, PhoneCall } from "lucide-react";
import { useLead } from "@/components/common/LeadModal";

const ITEMS = [
  { type: "devis", label: "Demande de devis", icon: FileText, testid: "dock-devis" },
  { type: "contact", label: "Contact", icon: Mail, testid: "dock-contact" },
  { type: "rappel", label: "Être rappelé", icon: PhoneCall, testid: "dock-rappel" },
];

export default function FloatingDock() {
  const { openLead } = useLead();

  return (
    <>
      {/* Desktop: right-edge vertical dock — always visible on every page */}
      <div
        className="fixed right-0 top-1/2 z-40 hidden -translate-y-1/2 flex-col gap-2 lg:flex"
        data-testid="floating-dock"
      >
        {ITEMS.map((item, i) => {
          const Icon = item.icon;
          const isPrimary = item.type === "devis";
          return (
            <motion.button
              key={item.type}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 + i * 0.1, duration: 0.4 }}
              onClick={() => openLead(item.type)}
              className={`group flex items-center gap-2.5 rounded-l-2xl py-3.5 pl-4 pr-4 text-sm font-semibold shadow-[0_10px_30px_rgba(0,35,102,0.25)] transition-all hover:pl-5 ${
                isPrimary
                  ? "bg-brand-red text-white hover:bg-brand-red-light"
                  : "bg-brand-blue text-white hover:bg-brand-blue-light"
              }`}
              data-testid={item.testid}
            >
              <Icon className="h-5 w-5 shrink-0" />
              <span className="whitespace-nowrap">{item.label}</span>
            </motion.button>
          );
        })}
      </div>

      {/* Mobile: bottom sticky bar with the two primary CTAs */}
      <div
        className="fixed inset-x-0 bottom-0 z-40 flex border-t border-white/10 lg:hidden"
        data-testid="floating-dock-mobile"
      >
        <button
          onClick={() => openLead("devis")}
          className="flex flex-1 items-center justify-center gap-2 bg-brand-red py-3.5 text-sm font-bold text-white"
          data-testid="dock-mobile-devis"
        >
          <FileText className="h-4 w-4" />
          Demande de devis
        </button>
        <button
          onClick={() => openLead("contact")}
          className="flex flex-1 items-center justify-center gap-2 bg-brand-blue py-3.5 text-sm font-bold text-white"
          data-testid="dock-mobile-contact"
        >
          <Mail className="h-4 w-4" />
          Contact
        </button>
      </div>
    </>
  );
}
